import { render, staticRenderFns } from "./role-purpose-direction.vue?vue&type=template&id=387c646c&"
import script from "./role-purpose-direction.vue?vue&type=script&lang=js&"
export * from "./role-purpose-direction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports